import { render } from "./UITextSelect.vue?vue&type=template&id=78c4b120&scoped=true&ts=true"
import script from "./UITextSelect.vue?vue&type=script&lang=ts"
export * from "./UITextSelect.vue?vue&type=script&lang=ts"

import "./UITextSelect.vue?vue&type=style&index=0&id=78c4b120&scoped=true&lang=css"

import exportComponent from "/root/app/github/pehuen-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78c4b120"]])

export default __exports__